import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {InsightsDatepickerComponent} from './insights-datepicker.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {DateRangePipe} from "../../../../pipes/date-range/date-range.pipe";
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [InsightsDatepickerComponent],
  providers: [MatDatepickerModule, MatNativeDateModule],
    imports: [
        CommonModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        DateRangePipe,
        TranslateModule,
    ],
  exports: [InsightsDatepickerComponent]
})
export class InsightsDatepickerModule { }
